import { render, staticRenderFns } from "./demandAdd.vue?vue&type=template&id=22a05822&scoped=true"
import script from "./demandAdd.vue?vue&type=script&lang=js"
export * from "./demandAdd.vue?vue&type=script&lang=js"
import style0 from "./demandAdd.vue?vue&type=style&index=0&id=22a05822&prod&scoped=true&lang=css"
import style1 from "./demandAdd.vue?vue&type=style&index=1&id=22a05822&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a05822",
  null
  
)

export default component.exports